<div *ngIf="device">
  <div class="card p-0 pt-4 mb-0">
    <div class="flex flex-column mx-4 mb-3">
      <div class="flex flex-column sm:flex-row justify-content-start sm:justify-content-between">
        <p class="inline-block text-4xl flex-order-1 sm:flex-order-0">
          {{'model.device' | transloco}} {{device.serialNumber}} ({{device.organization.name}})
        </p>
        <div class="flex-order-0 sm:flex-order-1">
          <button
            (click)="showSharedDialog(device)"
            [label]="'misc.sharedPopUp.share' | transloco"
            pButton
            pRipple
            class="mr-2 p-button-primary mt-1 mb-3 sm:mb-0 w-full sm:w-auto"
            icon="pi pi-share-alt"
          ></button>
          <button
            *ngIf="'ROLE_OPERATOR' | userHasRole"
            [label]="'common.edit' | transloco"
            pButton
            pRipple
            class="mr-2 p-button-primary mt-1 mb-3 sm:mb-0 w-full sm:w-auto"
            routerLink="../edit"
            icon="pi pi-pencil"
          ></button>
        </div>
      </div>
      <div>
        <p *ngIf="device.description" class="text-xl">{{'attribute.description' | transloco}}: {{device.description}}</p>
        <p *ngIf="!device.description" class="font-italic text-xl">{{'empty.description' | transloco}}</p>
      </div>
    </div>
    <div>
      <p-tabMenu
        #tab
        [model]="items"
        [activeItem]="activeItem"
        (click)="activateMenu(tab)"
        class="hidden xl:inline"
      ></p-tabMenu>
      <p-tabMenu
        #tabIcon
        [model]="items"
        [activeItem]="activeItem"
        (click)="activateMenu(tabIcon)"
        class="xl:hidden"
      >
        <ng-template pTemplate="item" let-item let-i="index">
          <i [className]="item.icon"></i>
        </ng-template>
      </p-tabMenu>
    </div>
  </div>
  <div *ngIf="items" class="with-margin">
    <app-device-overview [device]="device" *ngIf="activeItem.id == 'overview'"></app-device-overview>
    <app-device-sensors [device]="device" *ngIf="activeItem.id == 'sensors'"></app-device-sensors>
    <app-device-measures [device]="device" *ngIf="activeItem.id == 'measures'"></app-device-measures>
    <app-device-triggers [device]="device" *ngIf="activeItem.id == 'triggers'"></app-device-triggers>
    <app-device-events [navState]="navState" [device]="device" *ngIf="activeItem.id == 'events'"></app-device-events>
    <app-device-technical-details [device]="device" *ngIf="activeItem.id == 'technicalDetails'"></app-device-technical-details>
    <app-device-integration-modules [device]="device" *ngIf="activeItem.id == 'integrationModules'"></app-device-integration-modules>
    <app-device-commands [device]="device" *ngIf="activeItem.id == 'commands'"></app-device-commands>
    <app-device-nettopo [device]="device" *ngIf="activeItem.id == 'nettopo'"></app-device-nettopo>
    <app-device-diagnosis [device]="device" *ngIf="activeItem.id == 'diagnosis'"></app-device-diagnosis>
  </div>
</div>

<app-share-entity-dialog *ngIf="showDialog"
                         [sharedResources]="sharedResources"
                         [(dialogVisible)]="showDialog">
</app-share-entity-dialog>
